/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import Seo from "../../components/common/Seo";
import Header3 from "../../components/header/header-rslhome";
import Footer3 from "../../components/footer/footer-new";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import BookRideBar from "../../components/hero/hero-rslhome/BookRideBar";
import WhyBookWithUs from "../../components/WhyBookWithUs";
import { useSelector, useDispatch } from "react-redux";
import { getBookARidePage } from "../../redux/slices/common";
import { fetchSeoByPage } from "../../lib/seoHelper";

// const faqs = [
//   {
//     icon: "EmojiEmotionsIcon",
//     question: "Is there a free trial available?",
//     answer:
//       "Yes, you can try us for free for 30 days. If you want, we'll provide a free 30-minute onboarding call to get you up and running. Book a call here.",
//   },
//   {
//     icon: "ReceiptIcon",
//     question: "Can I change my plan later?",
//     answer:
//       "Absolutely. You can upgrade, downgrade, or cancel your plan anytime from your account settings.",
//   },
//   {
//     icon: "CreditCardIcon",
//     question: "What is your cancellation policy?",
//     answer:
//       "You can cancel your plan anytime. The current billing period will continue until the end of the cycle.",
//   },
//   {
//     icon: "PersonAddAlt1Icon",
//     question: "Can other info be added to an invoice?",
//     answer:
//       "You can cancel your plan anytime. The current billing period will continue until the end of the cycle.",
//   },
//   {
//     icon: "LocalAtmIcon",
//     question: "How does billing work?",
//     answer:
//       "We charge monthly or annually based on your plan. Invoices are automatically generated and emailed to you.",
//   },
//   {
//     icon: "EmailIcon",
//     question: "How do I change my account email?",
//     answer:
//       "We charge monthly or annually based on your plan. Invoices are automatically generated and emailed to you.",
//   },
//   {
//     icon: "MarkChatUnreadIcon",
//     question: "How does support work?",
//     answer:
//       "You can reach our support team 24/7 via email or live chat within your dashboard.",
//   },
//   {
//     icon: "PlayCircleOutlineIcon",
//     question: "Do you provide tutorials?",
//     answer:
//       "You can reach our support team 24/7 via email or live chat within your dashboard.",
//   }
// ];

// const features = [
//   {
//     title: "Feature 1",
//     description: "Lorem ipsum dolor sit amet consectetur. Bibendum nibh dignissim enim id orci nunc. Cursu",
//     image: "/img/cars/monrud.svg", // replace with your icon path
//   },
//   {
//     title: "Feature 2",
//     description: "Lorem ipsum dolor sit amet consectetur. Bibendum nibh dignissim enim id orci nunc. Cursu",
//     image: "/img/cars/monrud.svg", // replace with your icon path
//   },
//   {
//     title: "Feature 3",
//     description: "Lorem ipsum dolor sit amet consectetur. Bibendum nibh dignissim enim id orci nunc. Cursu",
//     image: "/img/cars/monrud.svg", // replace with your icon path
//   },
// ];

export default function Hourly({ meta }) {
  const dispatch = useDispatch();
  const { bookingRidePageRes } = useSelector(
    (state) => state.common
  );
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(true);


  useEffect(() => {
    setLoader(true);
    dispatch(getBookARidePage());
  }, [dispatch])


  // console.log("bookingRidePageRes",bookingRidePageRes);


  useEffect(() => {
    if (bookingRidePageRes) {
      setLoader(false);
      if (bookingRidePageRes?.status === 1) {
        setData(bookingRidePageRes?.responseData)
      } else {
        setData(null);
      }
    }
  }, [bookingRidePageRes])

  // console.log("data",data);


  return (
    <div style={{
      backgroundImage: "url('/img/banner/grid.svg')",
    }}>
      <div style={{ height: "150px" }}>
        <Seo meta={meta} />
        <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />
      </div>
      <div style={{ paddingTop: "40px", paddingBottom: "40px" }}>
        <BookRideBar hourly={true} />
      </div>
      <WhyBookWithUs loader={loader} faqs={data?.faqs} features={data?.features} title={data?.title} subtitle={data?.subtitle} />
      {/* Communication Section */}
      <CommunicationChannel data={{
        sectionId: "communicationChannel",
        image: {
          src: "/images/bannerImage/rsl_super_app.svg",
          alt: "RSL SUPER APP"
        }
      }} />

      {/* Footer */}
      <Footer3 bgcolor="#f8f8f8" />
    </div>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}